import React, {useState} from 'react';
import exampleWord from "./example-word.png" 

interface InstructionsProps {
    maxGuesses: number
    onClose: Function
}

export default function Instructions({maxGuesses, onClose}: InstructionsProps) {

    return (
        <div className="popup instructions-priority">
            <button onClick={ () => onClose() } id="exit-instructions">X</button>
            <div className="instructions-text">
                <h1>How to Play</h1>
                <p>You have <b>{maxGuesses}</b> turns to guess the urdle</p>
                <p>After each guess the letters will change colors depending on how close you were to guessing the word</p>
                <ul>
                    <li>Green is in the the word and in the correct spot</li>
                    <li>Yellow is in the word but in the incorrect spot</li>
                    <li>Red is not in the word</li>
                </ul>
                <img className="example-word" src={exampleWord} alt="Example word with two letters in the correct spot, one letter in the wrong spot, and 2 letters not in the word"></img>
            </div> 
        </div>
    );
}